function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".icon-error-bubble_svg__st3{fill:#fff;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon-error-bubble_svg__st3",
  d: "M66.5 83.5s15 22 37 6",
  id: "icon-error-bubble_svg__Layer_1"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon-error-bubble_svg__Layer_2"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-error-bubble_svg__st3",
  d: "M66.5 83.5s-21 2-23-17c0 0-2-23 25-21 0 0 7.06-10.9 17-12 9-1 15 7 15 7s14.83-.81 23 6c6 5 8 14 8 20s-5 26-28 23"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-error-bubble_svg__st3",
  cx: 63.5,
  cy: 102.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-error-bubble_svg__st3",
  cx: 47,
  cy: 113,
  r: 3.5
}));

function SvgIconErrorBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 153 157"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconErrorBubble;